import React, {useState} from "react";
import {File as DepotoFile} from "depoto-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './ImagePreview.css'

type Props = {
  image: DepotoFile
}
export const ImagePreview: React.FC<Props> = ({ image }) => {
  const [isImageShowed, setIsImageShowed] = useState<boolean>(false)

  const thumbUrl = image?.thumbnails?.length
    ? image.thumbnails.filter(t => t.format === 'w135')[0].url
    : null

  const imageUrl = image?.thumbnails?.length
    ? image.thumbnails.filter(t => t.format === 'w2048')[0].url
    : null

  if (!thumbUrl || !imageUrl) {
    return (
      <div className="image-thumbnail-container">
        <FontAwesomeIcon icon={'image-slash'} size="lg"/>
      </div>
    );
  }

  return (
    <>
      <div className="image-thumbnail-container" onClick={() => setIsImageShowed(true)}>
        <div className="image-thumbnail">
          <img src={thumbUrl} alt=""/>
        </div>
      </div>
      {isImageShowed && (
        <div className="image-preview-container slide-in-bck-center" onClick={() => setIsImageShowed(false)}>
          <div className="image-loader">
            <FontAwesomeIcon icon={'loader'} spin={true} size="5x"/>
          </div>
          <img className="slide-in-bck-center-delayed-500ms" src={imageUrl} alt=""/>
          <div className="image-preview-close">
            <FontAwesomeIcon icon={'times'} size="3x"/>
          </div>
        </div>
      )}
    </>
  )
}
